import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon, MenuIcon, XIcon } from 'lucide-react';
import { navItems } from '../../data/navigation';
import { Brand } from './Brand';
export function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    setOpen(false);
  }, [pathname, hash]);
  const isActive = (to: string) => {
    if (to === '/') return pathname === '/' && !hash;
    if (to.startsWith('/#')) return pathname === '/' && hash === to.slice(1);
    return pathname === to;
  };
  return <header className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${scrolled ? 'border-white/10 bg-ink/90 backdrop-blur-xl' : 'border-white/5 bg-transparent'}`} data-id="element-439" data-mp="3uejycm3h15k7">
      <div className="mx-auto flex max-w-8xl items-center justify-between gap-6 px-5 py-4 sm:px-8 lg:px-10" data-id="element-440" data-mp="bsf4clire0qt">
        <Brand data-id="element-441" data-mp="lkl2ye3ingez" />

        <nav aria-label="Primary" className="hidden items-center gap-0.5 lg:flex" data-id="element-442" data-mp="ll2w31uvteio">
          {navItems.map(item => <Link key={item.label} to={item.to} className={`relative rounded-lg px-3.5 py-2 text-[13.5px] font-medium transition-colors ${isActive(item.to) ? 'text-white' : 'text-mist-300 hover:text-white'}`} data-id="element-443" data-mp="3k38gambylafg">
              {item.label}
              {isActive(item.to) && <span className="absolute inset-x-3.5 -bottom-0.5 h-[2px] rounded-full bg-forge-orange" aria-hidden="true" data-id="element-444" data-mp="19affeujxb2yp" />}
            </Link>)}
        </nav>

        <div className="hidden lg:block" data-id="element-445" data-mp="1ddlhdq0067zd">
          <Link to="/#get-started" className="group inline-flex items-center gap-2 rounded-[10px] bg-forge-orange px-5 py-2.5 text-[13.5px] font-bold text-ink shadow-ember transition-transform hover:-translate-y-0.5" data-id="element-446" data-mp="3abbyd33rn3ce">
            Get Started
            <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" data-id="element-447" data-mp="3edgq1wanlpwe" />
          </Link>
        </div>

        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-nav" className="grid h-11 w-11 place-items-center rounded-[10px] border border-white/15 text-white lg:hidden" data-id="element-448" data-mp="2qonptnn00vvz">
          <span className="sr-only" data-id="element-449" data-mp="2vmp7c44s0n5c">{open ? 'Close menu' : 'Open menu'}</span>
          {open ? <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-450" data-mp="27x4qprw3i1z8" /> : <MenuIcon className="h-5 w-5" aria-hidden="true" data-id="element-451" data-mp="27vtmxs2ngu84" />}
        </button>
      </div>

      <AnimatePresence data-id="element-452" data-mp="22wqq2uwtpub8">
        {open && <motion.div id="mobile-nav" initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.24,
        ease: 'easeOut'
      }} className="overflow-hidden border-t border-white/10 bg-ink/95 lg:hidden" data-id="element-453" data-mp="ig93fos8983t">
            <nav aria-label="Mobile" className="mx-auto flex max-w-8xl flex-col px-5 py-3 sm:px-8" data-id="element-454" data-mp="ed312s88k12m">
              {navItems.map(item => <Link key={item.label} to={item.to} className="border-b border-white/5 px-1 py-3.5 text-[15px] font-medium text-mist-100" data-id="element-455" data-mp="166vb3eybkqda">
                  {item.label}
                </Link>)}
              <Link to="/#get-started" className="mt-4 mb-2 rounded-[10px] bg-forge-orange px-4 py-3.5 text-center text-[15px] font-bold text-ink" data-id="element-456" data-mp="3cwt7nf1h49m6">
                Get Started
              </Link>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}